import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import { getParcelsList } from '@/parcels/pages/ParcelsPage/pages/ParcelsListPage/helpers'

const InfoFailedParcelsText = ({ failedParcels }) => {
  const { t } = useTranslation()

  return (
    <Text type="bodyMRegular">
      {failedParcels?.length > 1
        ? t('Ha ocurrido un error al intentar preparar los envíos')
        : t('Ha ocurrido un error al intentar preparar el envío')}{' '}
      <Text type="bodyMBold" tag="span">
        {getParcelsList(
          failedParcels?.map(parcel => parcel.order?.name),
          t
        )}
      </Text>
      . {t('Por favor, revisa los envíos y vuelve a intentarlo.')}
    </Text>
  )
}

export default InfoFailedParcelsText
